import {
  initPlansSwitcher,
  initPlansSlider,
} from "../../components/pricing-plans/index.js";

document.addEventListener("DOMContentLoaded", () => {
  initPlansSwitcher();
  initPlansSlider();
});
